import { notification } from 'antd';

const notificationPopUp = ({
  type = 'error',
  description = '',
  message = 'Opss something went wrong!',
}) => notification[type]({ description, message });

export default notificationPopUp;
